import { useState } from 'react'
import './_endStats.scss'

import { useTranslation } from 'react-i18next'

import { IconCaret } from 'assets/svg/sprite'
import { addToast } from 'components/Toast/Toast'
import { type EndStreamStats } from 'features/LiveStream/LiveStreamCreator/LiveStreamCreator'
import { useSetSaveToVault } from 'services/endpoints/streaming'

import LiveLeaderboard from './LiveLeaderboard/LiveLeaderboard'
import LiveSummary from './LiveSummary/LiveSummary'

const navItems = ['summary', 'leaderboard'] as const

type EndStatsProps = {
  onClose?: () => void
  stats: EndStreamStats | null
  streamId: string | null
  initialSaveToVault?: boolean
}

const EndStats = ({
  onClose,
  stats,
  streamId,
  initialSaveToVault = true,
}: EndStatsProps) => {
  const [selectedTab, setSelectedTab] = useState<'summary' | 'leaderboard'>(
    'summary'
  )
  const [saveToVault, setSaveToVault] = useState(initialSaveToVault)

  const { t } = useTranslation()
  const setSaveToVaultMutation = useSetSaveToVault()

  const handleClose = async () => {
    try {
      if (streamId && saveToVault !== initialSaveToVault) {
        await setSaveToVaultMutation.mutateAsync({
          streamId,
          save_to_vault: saveToVault,
        })
      }

      onClose?.()
    } catch (error) {
      addToast('error', t('error:anErrorOccuredPleaseTryAgain'))
    }
  }

  return (
    <div className='endstats'>
      <div className='endstats__bg' />

      <div className='endstats__header'>
        <div className='endstats__header--back' onClick={handleClose}>
          <IconCaret />
        </div>

        <div className='endstats__header--title'>{t('liveVideoEnded')}</div>
      </div>

      <div className='endstats__nav'>
        <div className='tabnav'>
          {navItems.map(item => (
            <div
              key={item}
              className={`tabnav__item ${selectedTab === item ? 'active' : ''}`}
              onClick={() => setSelectedTab(item)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>

      <div className='endstats__content'>
        {selectedTab === 'summary' && (
          <LiveSummary
            stats={stats}
            saveToVault={saveToVault}
            onToggleSaveToVault={() => setSaveToVault(prev => !prev)}
            onClose={handleClose}
          />
        )}

        {selectedTab === 'leaderboard' && (
          <LiveLeaderboard
            stats={stats}
            onClose={handleClose}
          />
        )}
      </div>
    </div>
  )
}

export default EndStats